<template>
  <page-edicion :fluid="false">
    <page-header
      title="Crear motivo de cierre"
      subtitle="Motivo de cierre"
      back-to="/motivosCierreOferta"
    ></page-header>
    <formulario-motivo />
  </page-edicion>
</template>
<script>
import FormularioMotivo from "./FormularioMotivo.vue";

export default {
  components: { FormularioMotivo },
  data() {
    return {
      motivo: {},
    };
  },
};
</script>
